import {
  CloudUpload,
  UploadFile,
} from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { getTodaysDate } from '../utils/utils';

const AudioUploadComponent = ({
  showUploadPopup,
  setShowUploadPopup,
  categories,
  audioPopupNumber,
  setAudioPopupNumber,
  setFormData,
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [customFileName, setCustomFileName] = useState('');
  const [category, setCategory] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const triggerFileInput = () => {
    document.getElementById('file-input').click();
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file first.');
      return;
    }

    setUploading(true);
    setError('');
    console.log("LOG:", file)
    try {
      const finalFileName = customFileName
        ? `${customFileName}.${file.name.split('.').pop()}` // Use custom file name with original extension
        : `${file.name.split('.').slice(0, -1).join('')}_${Date.now()}.${file.name.split('.').pop()}`; // Default to original name with timestamp
        // return
      const formData = new FormData();
      formData.append('file', file); // Append the file
      formData.append('fileName', finalFileName);
      formData.append('folderId', file.type.startsWith('audio') ? process.env.REACT_APP_AUDIO_FOLDER_ID : process.env.REACT_APP_FILE_FOLDER_ID); // Dynamic folder ID based on file type

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/upload-file`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();

      if (response?.ok) {
        setFormData((prev) => ({
          ...prev,
          [`File ${audioPopupNumber} Name`]: customFileName || file.name,
          [`File ${audioPopupNumber} Category`]: category,
          [`File ${audioPopupNumber} URL`]: data.url,
          [`File ${audioPopupNumber} Date`]: getTodaysDate(),
        }));
      }

      setFile(null);
      setCustomFileName('');
      setShowUploadPopup(false);
    } catch (err) {
      console.error('Error uploading file:', err);
      setError('Failed to upload file.');
    } finally {
      setUploading(false);
    }
  };

  const handleChange = (event, value) => {
    if (event) {
      const { value } = event.target;
      setCategory(value);
    } else {
      setCategory(value);
    }
  };

  return (
    <Dialog open={showUploadPopup} className="audio_input_dialog_main">
      <DialogTitle>Upload File</DialogTitle>
      <DialogContent>
        <Container className="upload_audio_container">
          <input
            id="file-input"
            type="file"
            accept="audio/*,video/*,text/plain,application/pdf,image/*"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />

          <IconButton
            className="audio_upload_icon_button"
            color="primary"
            component="span"
            onClick={triggerFileInput}
          >
            <UploadFile fontSize="large" />
          </IconButton>
         

          {file && <p>{file.name}</p>}

          {file && (
            <TextField
              label="Custom Filename (optional)"
              variant="outlined"
              fullWidth
              value={customFileName}
              onChange={(e) => setCustomFileName(e.target.value)}
              placeholder="Enter filename without extension"
              style={{ marginTop: '1rem', marginBottom: '1rem' }}
            />
          )}

          
            <Autocomplete
              sx={{ mt: 2 }}
              id="category-input"
              freeSolo
              fullWidth
              options={categories}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField {...params} label="Category" onChange={handleChange} />
              )}
              onChange={(event, value) => handleChange(null, value)}
            />
          

          {error && <p style={{ color: 'red' }}>{error}</p>}
          <Typography variant='subtitle2' sx={{color:"#747474"}}>
            Select files to upload (Audio, Video, Image, PDF, Text formats allowed)
          </Typography>
         
        </Container>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setShowUploadPopup(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={uploading ? <CircularProgress size={24} /> : <CloudUpload />}
          onClick={handleUpload}
          disabled={uploading || !file}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AudioUploadComponent;
